import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { mediaApi } from "../api";
import MediaHero from "../components/MediaHero";
import MediaRow from "../components/MediaRow";

export default function MediaHome() {
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");
  const [teasers, setTeasers] = useState([]);

  useEffect(() => {
    mediaApi.home().then(setData).catch((e) => setErr(e.message || "Erro"));
    mediaApi.teaserAudios(1).then(setTeasers).catch(() => setTeasers([]));
  }, []);

  if (err) return <div className="px-6 py-20 text-center text-slate-400" data-testid="media-home-error">{err}</div>;
  if (!data) return (
    <div className="px-6 py-40 grid place-items-center">
      <div className="flex items-center gap-3 text-slate-400">
        <div className="live-dot" /> A carregar Media Center...
      </div>
    </div>
  );

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="-mt-16"
      data-testid="media-home"
    >
      <MediaHero items={data.featured} />
      <div className="pb-24 space-y-2">
        {teasers.length > 0 && (
          <MediaRow
            key="teasers"
            rowKey="teasers"
            title="Experimenta por conta da casa · Áudio do dia"
            items={teasers}
          />
        )}
        {data.rows.map((r) => (
          <MediaRow
            key={r.key}
            rowKey={r.key}
            title={r.title}
            items={r.items}
            showProgress={r.key === "continue"}
          />
        ))}
      </div>
    </motion.div>
  );
}
